module.exports = __webpack_public_path__ + "static/media/Highgate Close N6 (13).8d191dce.JPG";